module.exports = "/fonts/eppt-logotype-d-92e7d4432bee8b012505fe91bd49629d.svg";